import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import { Icon } from "./icon";
import styles from "./styles.scss";

function Header({ sort, setSort }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.header}>
      <div
        onClick={() =>
          setSort(
            sort === "ascendingName"
              ? "descendingName"
              : sort === "descendingName"
                ? "ascendingName"
                : "ascendingName",
          )
        }
      >
        <p className={styles.label}>
          {t("projectPage.documentsPage.documentsPage.header.name")}
        </p>
        <Icon
          className={styles.icon}
          isAscending={sort === "ascendingName"}
          isDescending={sort === "descendingName"}
        />
      </div>
      <div
        onClick={() =>
          setSort(
            sort === "ascendingAuthor"
              ? "descendingAuthor"
              : sort === "descendingAuthor"
                ? "ascendingAuthor"
                : "ascendingAuthor",
          )
        }
      >
        <p className={styles.label}>
          {t("projectPage.documentsPage.documentsPage.header.createdBy")}
        </p>
        <Icon
          className={styles.icon}
          isAscending={sort === "ascendingAuthor"}
          isDescending={sort === "descendingAuthor"}
        />
      </div>
      <div
        onClick={() =>
          setSort(
            sort === "ascendingCreationDate"
              ? "descendingCreationDate"
              : sort === "descendingCreationDate"
                ? "ascendingCreationDate"
                : "ascendingCreationDate",
          )
        }
      >
        <p className={styles.label}>
          {t("projectPage.documentsPage.documentsPage.header.creationDate")}
        </p>
        <Icon
          className={styles.icon}
          isAscending={sort === "ascendingCreationDate"}
          isDescending={sort === "descendingCreationDate"}
        />
      </div>
      <div />
    </div>
  );
}

export { Header };
